import {createFileRoute} from '@tanstack/react-router';
import SuccessIcon from '@/icons/success.svg';

export const Route = createFileRoute('/subscription/success')({
  component: SubscriptionSuccessPage,
});

function SubscriptionSuccessPage() {
  return (
    <div className='flex min-h-screen flex-col items-center justify-center text-center'>
      <title>Banani | Thank you!</title>
      <SuccessIcon className='mb-2' />
      <h1 className='mb-1 text-[22px] font-semibold'>
        Subscription activated!
      </h1>
      <p className='text-sm font-medium opacity-70'>
        You can now close this tab and return
        <br />
        to the previous window.
      </p>
    </div>
  );
}
